import { isPublicEnvConfigured } from '@/lib/app-public-env';

export function getApiBaseUrl(): string | null {
  const url = process.env.EXPO_PUBLIC_API_URL?.trim();
  return url || null;
}

export function requireApiBaseUrl(): string {
  const url = getApiBaseUrl();
  if (!url) {
    throw new Error('API_NOT_CONFIGURED');
  }
  return url;
}

export function isApiConfigured(): boolean {
  return isPublicEnvConfigured() && !!getApiBaseUrl();
}

/**
 * Headers exigidos pelo host da API, não pela API em si. Túnel ngrok free
 * intercepta request com user-agent de browser e devolve uma página de aviso
 * em HTML (ERR_NGROK_6024) no lugar da resposta; o header pula essa página.
 * Vazio quando a API não está atrás de ngrok.
 */
export function getApiHostHeaders(): Record<string, string> {
  return getApiBaseUrl()?.includes('ngrok')
    ? { 'ngrok-skip-browser-warning': 'true' }
    : {};
}
